import { Conn_Db } from "src/app/shared/models/datapoint/conn_db";
import { CommonEnums } from 'src/app/shared/common.enums';
import { RepConnWrapper } from '../../../modules/repconn/repconn.wrapper';
import { Util } from '../../utils/util';
import { ObjectWrapperUtil } from '../../utils/object.wrapper.util';
import { DatabaseEnum } from "../../databases/databases.enum";

export class Conn_DbTabulator {
    getSrt_Order(): any {
        let column: any = {};
        column.title = "#";
        column.width = 50;
        column.field = 'srt_Order';
        column.headerSort = false;

        column.formatter = function (cell) {
            return "<div style='padding-top: 5px'>" + (cell.getValue() + 1) + "</div>";
        }

        return column;
    }

    getCheckBoxColumn(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.formatter = "rowSelection"
        column.width = 40;
        column.align = "center";
        column.titleFormatter = "rowSelection"
        column.resizableColumn = false;
        column.headerSort = false;
        column.visible = repConnWrapper.mode_Ind == CommonEnums.mode_Ind.WRITE;
        // if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return column;

        return column;
    }

    getName(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.title = "Name";
        column.width = 200;
        column.field = 'nm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.formatter = function (cell) {
            return "<div style='padding-top: 5px'>" + cell.getValue() + "</div>";
        }

        column.editor = function (cell, onRendered, success) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;
            let oldConnDbNm: string = conn_Db.nm;

            let divElement: any = document.createElement('div');
            divElement.setAttribute("style", "padding-top: 5px");
            if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return;

            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            function successFunc() {
                conn_Db.nm = editor.value;

                if (conn_Db.nm == "") {
                    editor.value = oldConnDbNm;
                    conn_Db.nm = editor.value;
                }

                if (editor.value != oldConnDbNm) {
                    if (repConnWrapper.subNames.indexOf(editor.value.toUpperCase()) != -1) {
                        editor.value = oldConnDbNm;
                    } else {
                        ObjectWrapperUtil.getInstance().updateSubName(editor.value, oldConnDbNm, repConnWrapper);
                        conn_Db.dbParamNm = Util.getInstance().updateDbParamNm(repConnWrapper, conn_Db);
                        conn_Db.schemaParamNm = Util.getInstance().updateSchemaParamName(repConnWrapper, conn_Db);
                        repConnWrapper.doValidate();
                    }
                }

                success(editor.value);
            }

            editor.addEventListener("blur", successFunc);

            divElement.appendChild(editor);

            return divElement;
        }

        return column;
    }

    getDatabaseNm(repConnWrapper: RepConnWrapper, component: any): any {
        let column: any = {};
        if (repConnWrapper.dbTyp_Id === DatabaseEnum.databaseId.SHAREPOINT) {    
            column.title = "Site";  // Set title to "Site" for SharePoint   
            }else if (repConnWrapper.dbTyp_Id === DatabaseEnum.databaseId.ICEBERG) {    
            column.title = "Tables";  // Set title to "Tables" for Iceberg   
            }else {        
                column.title = "Database"; // Default title for other databases 
            }
        //column.title = "Database";
        column.width = 200;
        column.field = "databaseNm";
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.formatter = function (cell, onRendered, success) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;
            let oldValue: string = cell.getValue();
            let option: any;
            let loadingMsg: string = "Loading databases...";
            let emptySpaces: string = "  ";
            if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return conn_Db.databaseNm ;

            // root div element.
            let editor: any = document.createElement('div');
            editor.setAttribute('class', 'di-flex-row');

            // creating select control.
            let select: any = document.createElement("select");
            select.setAttribute('class', 'form-control');
            select.setAttribute('style', 'border:0px; outline:0px; cursor: pointer; ');
            select.id = "select_database_" + conn_Db.conn_Db_Id;

            // defaultly, adding 5 options with empty space to get the select dropdown height.
            addEmptyOptions();

            select.value = conn_Db.databaseNm;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.appendChild(select);

            // Overlaying the input on the select control..
            let inputElement: any = document.createElement('input');
            inputElement.setAttribute('class', 'form-control');
            inputElement.setAttribute('style', 'position: absolute; height: 30px; width: calc(100% - 32px); border:0px; outline:0px;');
            inputElement.value = conn_Db.databaseNm;
            editor.appendChild(inputElement);

            // upon clicking the select dropdown.
            function onSelectClick() {
                // removing all defaultly added options, still height will be retained. 
                removeAllSelectOptions();

                // append all existing databases.
                if (repConnWrapper.databaseList.length > 0) {
                    setDatabasesList();
                    return;
                }

                component.busyCursor.incrementCount();

                // showing loading databases... by adding one option to the select.
                option = document.createElement("option");
                option.appendChild(document.createTextNode(loadingMsg));
                option.value = loadingMsg;
                select.appendChild(option);

                // test connection call for getting all the databases..
                component.testRepconn(null, true)
                    .subscribe(() => {
                        // remove loading databases... option
                        removeAllSelectOptions();

                        if (repConnWrapper.databaseList.length == 0) {
                            // defaultly, adding 5 options with empty space to get the select dropdown height.
                            addEmptyOptions();
                            select.blur();
                        } else {
                            // append all fetched databases.
                            setDatabasesList();
                        }

                        component.busyCursor.decrementCount();
                    });
            }

            function removeAllSelectOptions() {
                while (select.firstChild) {
                    select.removeChild(select.lastChild);
                }
            }

            function addEmptyOptions() {
                for (let i: number = 0; i < 5; i++) {
                    let option: any = document.createElement("option");
                    option.appendChild(document.createTextNode(emptySpaces));
                    option.value = emptySpaces;
                    select.appendChild(option);
                }
            }

            function setDatabasesList() {
                for (let i: number = 0; i < repConnWrapper.databaseList.length; i++) {
                    option = document.createElement("option");
                    option.appendChild(document.createTextNode(repConnWrapper.databaseList[i]));
                    option.value = repConnWrapper.databaseList[i];
                    select.appendChild(option);
                }

                select.value = conn_Db.databaseNm;
            }

            function onSelectChangeOrBlur() {
                if (select.value == "undefined" ||
                    select.value == loadingMsg ||
                    select.value == emptySpaces ||
                    select.value == "") {
                    return;
                }

                inputElement.value = select.value;
                conn_Db.databaseNm = select.value;

                repConnWrapper.doValidate();
            }
            select.addEventListener("click", onSelectClick);
            select.addEventListener("change", onSelectChangeOrBlur);
            select.addEventListener("blur", onSelectChangeOrBlur);

            function inputChangeOrBlur() {
                if (inputElement.value == "") {
                    inputElement.value = oldValue;
                    return;
                }

                conn_Db.databaseNm = inputElement.value;
                oldValue = inputElement.value;

                repConnWrapper.doValidate();
            }
            editor.addEventListener("change", inputChangeOrBlur);
            editor.addEventListener("blur", inputChangeOrBlur);

            return editor;
        }

        return column;
    }

    loadShemas(repConnWrapper: RepConnWrapper, component: any) {
        let column: any = {};
        column.title = "";
        column.width = 50;
        column.field = '';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.formatter = function (cell, onRendered, success) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;

            let imgDivElement = document.createElement('div');
            imgDivElement.classList.add("hand");
            let imgElement = document.createElement('img');
            imgElement.setAttribute('src', 'assets/icons/common/database-refresh.svg');
            imgDivElement.appendChild(imgElement);

            function successFunc() {
                component.testRepconn(conn_Db, true);
            }
            imgDivElement.addEventListener("click", successFunc);

            return imgDivElement;
        }

        return column;
    }

    getSchemaNm(repConnWrapper: RepConnWrapper, component: any): any {
        let column: any = {};
        if (repConnWrapper.dbTyp_Id === DatabaseEnum.databaseId.SHAREPOINT) {       
            return this.getDatabaseNm; // Return null to hide the column for SharePoint 
          }
        column.title = "Schema";
        column.width = 200;
        column.field = "schemaNm";
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.formatter = function (cell, onRendered, success) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;
            let oldValue: string = cell.getValue();
            let loadingMsg: string = "Loading schemas...";
            let emptySpaces: string = "  ";
            let options: Array<string> = new Array<string>();
            let option: any;
            if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) return conn_Db.schemaNm ;

            // root div element.
            let editor: any = document.createElement('div');
            editor.setAttribute('class', 'di-flex-row');

            // creating select control.
            let select: any = document.createElement("select");
            select.setAttribute('class', 'form-control');
            select.setAttribute('style', 'border:0px; outline:0px; cursor: pointer;');
            select.id = "select_schema_" + conn_Db.conn_Db_Id;

            // defaultly, adding 5 options with empty space to get the select dropdown height.
            addEmptyOptions();

            select.value = conn_Db.schemaNm;

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";
            editor.appendChild(select);

            let inputElement: any = document.createElement('input');
            inputElement.setAttribute('class', 'form-control');
            inputElement.setAttribute('style', 'position: absolute; height: 30px; width: calc(100% - 32px); border:0px; outline:0px;');
            inputElement.value = conn_Db.schemaNm;
            editor.appendChild(inputElement);

            function onSelectClick() {
                // removing all defaultly added options, still height will be retained. 
                removeAllSelectOptions();

                // append all existing schemas.
                if (options.length > 0) {
                    setSchemasList();
                    return;
                }

                component.busyCursor.incrementCount();

                // showing loading schemas... by adding one option to the select.
                option = document.createElement("option");
                option.appendChild(document.createTextNode(loadingMsg));
                option.value = loadingMsg;
                select.appendChild(option);

                if (repConnWrapper.databaseWrapper.havingOnlySchemalColumn) {
                    component.testRepconn(null, true)
                        .subscribe(() => {
                            // remove loading schemas... option
                            removeAllSelectOptions();

                            options = repConnWrapper.databaseWrapper.havingOnlySchemalColumn ? repConnWrapper.databaseList : conn_Db.schemaList;
                            if (options.length == 0) {
                                // defaultly, adding 5 options with empty space to get the select dropdown height.
                                addEmptyOptions();
                                select.blur();
                            } else {
                                // append all fetched schemas.
                                setSchemasList();
                            }

                            component.busyCursor.decrementCount();
                        })
                } else {
                    component.testRepconn(conn_Db, true)
                        .subscribe(() => {
                            // remove loading schemas... option
                            removeAllSelectOptions();

                            options = repConnWrapper.databaseWrapper.havingOnlySchemalColumn ? repConnWrapper.databaseList : conn_Db.schemaList;
                            if (options.length == 0) {
                                // defaultly, adding 5 options with empty space to get the select dropdown height.
                                addEmptyOptions();
                                select.blur();
                            } else {
                                // append all fetched schemas.
                                setSchemasList();
                            }

                            component.busyCursor.decrementCount();
                        })
                }
            }

            function addEmptyOptions() {
                for (let i: number = 0; i < 5; i++) {
                    let option: any = document.createElement("option");
                    option.appendChild(document.createTextNode(emptySpaces));
                    option.value = emptySpaces;
                    select.appendChild(option);
                }
            }

            function removeAllSelectOptions() {
                while (select.firstChild) {
                    select.removeChild(select.lastChild);
                }
            }

            function setSchemasList() {
                options = repConnWrapper.databaseWrapper.havingOnlySchemalColumn ? repConnWrapper.databaseList : conn_Db.schemaList;
                for (let i: number = 0; i < options.length; i++) {
                    option = document.createElement("option");
                    option.appendChild(document.createTextNode(options[i]));
                    option.value = options[i];
                    select.appendChild(option);
                }

                select.value = conn_Db.schemaNm;
            }

            function onSelectChangeOrBlur() {
                if (select.value == "undefined" ||
                    select.value == loadingMsg ||
                    select.value == emptySpaces ||
                    select.value == "") {
                    return;
                }

                inputElement.value = select.value;
                conn_Db.schemaNm = select.value;

                //repConnWrapper.doValidate();
            }
            select.addEventListener("click", onSelectClick);
            select.addEventListener("change", onSelectChangeOrBlur);
            select.addEventListener("blur", onSelectChangeOrBlur);

            function inputChange() {
                if (inputElement.value == "") {
                    inputElement.value = oldValue;
                    return;
                }

                if (ObjectWrapperUtil.getInstance().hasPPWithAtSign(inputElement.value)) {
                    inputElement.value = conn_Db.schemaNm = oldValue;
                    return;
                }

                conn_Db.schemaNm = inputElement.value;
                oldValue = inputElement.value;

                conn_Db.dbParamNm = Util.getInstance().updateDbParamNm(repConnWrapper, conn_Db);
                conn_Db.schemaParamNm = Util.getInstance().updateSchemaParamName(repConnWrapper, conn_Db);

                repConnWrapper.doValidate();
            }
            editor.addEventListener("change", inputChange);
            editor.addEventListener("blur", inputChange);

            return editor;
        }

        return column;
    }

    getOwnerName(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.title = "Owner Name";
        column.width = 200;
        column.field = 'schemaNm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.editor = function (cell, onRendered, success) {
            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            let oldValue: string = cell.getValue();
            function successFunc() {
                if (editor.value == oldValue) {
                    success(editor.value);
                    return;
                }

                success(editor.value);
                repConnWrapper.doValidate();
            }
            editor.addEventListener("blur", successFunc);
            editor.addEventListener("change", successFunc);

            return editor;
        }

        return column;
    }

    getRefName(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.title = "Ref Name";
        column.width = 200;
        column.field = 'databaseNm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.editor = function (cell, onRendered, success) {
            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();

            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            let oldValue: string = cell.getValue();
            function successFunc() {
                if (editor.value == oldValue) {
                    success(editor.value);
                    return;
                }

                success(editor.value);
                repConnWrapper.doValidate();
            }
            editor.addEventListener("blur", successFunc);
            editor.addEventListener("change", successFunc);

            return editor;
        }

        return column;
    }

    getPath(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.title = "Path";
        column.width = 200;
        column.field = 'schemaNm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.editor = function (cell, onRendered, success) {
            let editor = document.createElement("input");
            editor.type = 'text';
            editor.id = "myInput";
            editor.value = cell.getValue();
            editor.style.width = "100%";
            editor.style.boxSizing = "border-box";

            onRendered(function () {
                editor.focus();
            });

            let oldValue: string = cell.getValue();
            function successFunc() {
                if (editor.value == oldValue) {
                    success(editor.value);
                    return;
                }

                success(editor.value);
                repConnWrapper.doValidate();
            }

            editor.addEventListener("blur", successFunc);
            editor.addEventListener("change", successFunc);
            return editor;
        }

        return column;
    }

    getProjectId(repConnWrapper: RepConnWrapper, component: any): any {
        let column: any = {};
        column.title = "Project Id";
        column.width = 200;
        column.field = 'schemaNm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.formatter = function (cell, onRendered, success) {
            // let editor = document.createElement("input");
            // editor.type = 'text';
            // editor.id = "myInput";
            // editor.value = cell.getValue();
            // editor.style.width = "100%";
            // editor.style.boxSizing = "border-box";

            // onRendered(function () {
            //     editor.focus();
            // });

            // function successFunc() {
            //     success(editor.value);
            //     repConnWrapper.doValidate();
            // }

            // editor.addEventListener("blur", successFunc);
            // editor.addEventListener("change", successFunc);
            // return editor;
            let conn_Db: Conn_Db = cell.getRow()._row.data;

            let editorElement = document.createElement('div');
            editorElement.setAttribute('class', 'exp-field');

            let inputElement = document.createElement('input');
            inputElement.setAttribute('type', 'text');
            inputElement.setAttribute('class', 'form-control form-control-sm exp-button');
            inputElement.setAttribute('value', conn_Db.schemaNm);

            editorElement.appendChild(inputElement);

            let element: any = document.createElement('button');
            element.setAttribute('class', 'fa fa-angle-right');
            document.body.appendChild(element);

            // onRendered(function () {
            //     inputElement.focus();
            // });

            function successFunc() {
                success(inputElement.value);
                repConnWrapper.doValidate();
            }

            inputElement.addEventListener("blur", successFunc);
            inputElement.addEventListener("change", successFunc);

            function onClick() {
                component.getDataSet(conn_Db);
            }

            element.addEventListener("click", onClick);
            editorElement.appendChild(element);
            return editorElement;
        }

        return column;
    }

    getDatasets(repConnWrapper: RepConnWrapper): any {
        let column: any = {};
        column.title = "Datasets";
        column.width = 200;
        column.field = 'databaseNm';
        column.headerSort = false;

        if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            return column;
        }

        column.editor = function (cell, onRendered, success) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;
            let editor: any;

            if (conn_Db.datasetsList.length != 0) {
                editor = document.createElement("select");
                editor.id = "mySelect";

                for (let i: number = 0; i < conn_Db.datasetsList.length; i++) {
                    let option = document.createElement("option");

                    option.value = conn_Db.datasetsList[i];
                    option.text = conn_Db.datasetsList[i];

                    editor.appendChild(option);
                }
            } else {
                editor = document.createElement("input");
                editor.type = 'text';
                editor.id = "myInput";
                editor.value = cell.getValue();
                editor.style.width = "100%";
                editor.style.boxSizing = "border-box";
            }

            onRendered(function () {
                editor.focus();
            });

            let oldValue: string = cell.getValue();
            function successFunc() {
                if (editor.value == oldValue) {
                    success(editor.value);
                    return;
                }

                success(editor.value);
                repConnWrapper.doValidate();
            }
            editor.addEventListener("blur", successFunc);
            editor.addEventListener("change", successFunc);

            return editor;
        }

        return column;
    }

    getStgDb_Flag(repConnWrapper: RepConnWrapper, showTranspose: boolean = false): any {
        let column: any = {};
        if (repConnWrapper.dbTyp_Id === DatabaseEnum.databaseId.SHAREPOINT) {       
            return this.getDatabaseNm; // Return null to hide the column for SharePoint 
          }
        column.title = "Transforms";
        column.field = 'stgDb_Flag';
        column.width = 90;
        column.headerSort = false;

        column.visible = !showTranspose;

        column.formatter = function (cell, formatterParams) {
            let conn_Db: Conn_Db = cell.getRow()._row.data;

            let editor = document.createElement('input');
            editor.type = "checkbox";
            editor.name = "stgDb_Flag_" + conn_Db.conn_Db_Id;
            editor.id = "stgDb_Flag_" + conn_Db.conn_Db_Id;

            editor.checked = conn_Db.stgDb_Flag == CommonEnums.flag.YES;

            if (repConnWrapper.mode_Ind != CommonEnums.mode_Ind.WRITE) {
                editor.setAttribute("disabled", "true");
                return editor;
            }

            editor.onclick = function (event: any) {
                conn_Db.stgDb_Flag = event.target.checked ? CommonEnums.flag.YES : CommonEnums.flag.NO;
                cell.getRow().reformat();

                if (conn_Db.stgDb_Flag == CommonEnums.flag.YES) {
                    let rows: Array<any> = cell.getTable().getRows();
                    for (let i: number = 0; i < rows.length; i++) {
                        let conn_DbTmp: Conn_Db = rows[i]._row.data;
                        if (conn_DbTmp.conn_Db_Id == conn_Db.conn_Db_Id) continue;
                        conn_DbTmp.stgDb_Flag = CommonEnums.flag.NO;
                        rows[i].reformat();
                    }
                }

                repConnWrapper.stgDb_FlagChanged();
            }

            return editor;
        }

        // if (repConnWrapper.mode_Ind == CommonEnums.mode_Ind.WRITE) {
        //     column.cellClick = function (e, cell) {

        //         let conn_Db: Conn_Db = cell._cell.row.data;
        //         let rowIndex = cell.getRow().getIndex();
        //         conn_Db.stgDb_Flag = conn_Db.stgDb_Flag == CommonEnums.stgDb_Flag.YES ? CommonEnums.stgDb_Flag.NO : CommonEnums.stgDb_Flag.YES;

        //         let updateConn_Dbs: Array<Conn_Db> = new Array<Conn_Db>();
        //         let updateConn_Db_ids: Array<number> = new Array<number>();
        //         updateConn_Dbs.push(conn_Db);
        //         updateConn_Db_ids.push(rowIndex);
        //         for (let i: number = 0; i < cell._cell.table.rowManager.rows.length; i++) {
        //             let conn_DbTmp: Conn_Db = cell._cell.table.rowManager.rows[i].data;
        //             if (conn_DbTmp.conn_Db_Id == conn_Db.conn_Db_Id) continue;
        //             if (conn_DbTmp.stgDb_Flag == CommonEnums.stgDb_Flag.YES) {
        //                 conn_DbTmp.stgDb_Flag = CommonEnums.stgDb_Flag.NO;
        //                 updateConn_Dbs.push(conn_DbTmp);
        //                 updateConn_Db_ids.push(conn_Db.conn_Db_Id);
        //             }
        //         }
        //         let table: any = cell.getTable(); 
        //         table.updateRow(updateConn_Db_ids, updateConn_Dbs);
        //         // cell.getTable().updateData(updateConn_Dbs);
        //         repConnWrapper.doValidate();
        //     }
        // }
        return column;
    }
}